import { DropdownWrapper, HeightLimitedDropdownMenu, SpDropdownItem } from 'components/shared/Dropdown';
import { CurrencyFlagIcon } from 'components/shared/WithCountryFlag';
import { DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { currencyFilters } from './BlotterFilterNext.helpers';

interface CurrencyFilterProps {
  currencyFilter?: string;
  onCurrencyFilterChanged(value: string): void;
}

export function CurrencyFilter({ currencyFilter, onCurrencyFilterChanged }: CurrencyFilterProps) {
  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover>
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        name="currencyFilter"
        data-e2e="currency-filter"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
      >
        {currencyFilter === 'allCurrencies' || !currencyFilter ? (
          <i className="icon">money</i>
        ) : (
          <CurrencyFlagIcon currency={currencyFilter} />
        )}
        <span className="d-none d-lg-inline">
          {currencyFilter !== 'allCurrencies' ? (
            currencyFilter
          ) : (
            <FormattedMessage id="blotter.filter.currency.allCurrencies" />
          )}
        </span>
      </DropdownToggle>
      <HeightLimitedDropdownMenu role="listbox">
        <SpDropdownItem
          active={currencyFilter === 'allCurrencies'}
          onClick={() => onCurrencyFilterChanged('allCurrencies')}
        >
          <FormattedMessage id="blotter.filter.currency.allCurrencies" />
        </SpDropdownItem>
        {currencyFilters.map(currency => (
          <SpDropdownItem
            active={currency === currencyFilter}
            key={currency}
            onClick={() => onCurrencyFilterChanged(currency)}
          >
            <CurrencyFlagIcon currency={currency} className="me-2" />
            {currency}
          </SpDropdownItem>
        ))}
      </HeightLimitedDropdownMenu>
    </DropdownWrapper>
  );
}
